__turbopack_context__.v({
  "card": "HeroHeader-module-scss-module__sIVqnG__card",
  "container": "HeroHeader-module-scss-module__sIVqnG__container",
  "iconBackground": "HeroHeader-module-scss-module__sIVqnG__iconBackground",
  "iconContainer": "HeroHeader-module-scss-module__sIVqnG__iconContainer",
  "link": "HeroHeader-module-scss-module__sIVqnG__link",
  "list": "HeroHeader-module-scss-module__sIVqnG__list",
  "section": "HeroHeader-module-scss-module__sIVqnG__section",
  "serviceDescription": "HeroHeader-module-scss-module__sIVqnG__serviceDescription",
  "serviceTitle": "HeroHeader-module-scss-module__sIVqnG__serviceTitle",
  "subtitle": "HeroHeader-module-scss-module__sIVqnG__subtitle",
  "title": "HeroHeader-module-scss-module__sIVqnG__title",
});
